module.exports = __webpack_public_path__ + "img/creating better days.a5513aeb.png";